import { action, computed } from 'mobx';
import { ViewController } from '@estee/elc-service';
import { LoadLoyaltyInfoUseCase } from '~use-cases/LoadLoyaltyInfoUseCase';
import { AnalyticalTrackingUseCase } from '~use-cases/AnalyticalTrackingUseCase';
import { eventTag } from '~utils/Analytics';

class LoyaltyEarnPointsController extends ViewController {
    public loaded = async () => {
        this.isLoading = true;
        await new LoadLoyaltyInfoUseCase().execute();
        this.isLoading = false;
    };

    @computed public get data() {
        return {
            isLoading: this.isLoading
        };
    }

    @action
    public onEarnLinkClick = (eLabel: string) => {
        const LoyaltyEventTracking = new AnalyticalTrackingUseCase(
            { event_name: 'loyalty_earn_points', event_action: 'cta_click', event_label: eLabel },
            eventTag.LOYALTY_ACTIONS_TRACKING
        );
        LoyaltyEventTracking.execute();
    };

    @action
    public onEarnPointsArrowClick(eLabel: string) {
        const LoyaltyEventTracking = new AnalyticalTrackingUseCase(
            { event_name: 'loyalty_earn_points', event_action: 'arrow_click', event_label: eLabel },
            eventTag.LOYALTY_ACTIONS_TRACKING
        );
        LoyaltyEventTracking.execute();
    }
}

export default LoyaltyEarnPointsController;
